export default __webpack_public_path__ + "locales/pl/Article.json?hash=af1d6bee83569634977e7d09bc52299d";